module.exports = __webpack_public_path__ + "media/images/offers/small_pack-571369f8783bd9c40cd0b3afd2723487.svg";